
import React, { Component}  from 'react';

import { FormContext } from 'core/FormProvider';
import { ContextFormControlWidget } from 'form/Contexed';
import {AsyncAutocompleteWidget} from "form/AutocompleteWidget";


export default class TariffOrderForm extends Component {
  render() {
    return (
      <FormContext.Consumer>
        {context => {
          const { item } = context;

          return (
            <React.Fragment>
              <ContextFormControlWidget
                name={'tariff'}
                WidgetComponent={AsyncAutocompleteWidget}
                widgetProps={{
                  label: 'Тариф',
                  url: 'tariff',
                  optionLabel: 'name',
                  filter: {
                    is_active: true,
                    carrier: item.carrier ? item.carrier.id : null,
                    counterparty: item.counterparty ? item.counterparty.id : null
                  },
                  onChange: (value) => context.setValue('tariff', value)
                }}
              />
            </React.Fragment>
          )
        }}
      </FormContext.Consumer>
    )
  }
}
